module.exports = "/_next/static/images/Collection-4da2983aac0c509d59f26aa95388dee8.webp";